import { getBMI } from "utils/bmi";
import {
  DESIRED_WEIGHT,
  MINIMUM_BMI,
  MINIMUM_BMI_RECOMMENDED,
  WEIGHT,
  WEIGHT_UNIT
} from "../constants";
import convertWeight, { getWeightLocalized } from "utils/weightUnits";
import { BMI_MESSAGE, BMI_MESSAGE_CURRENT_WEIGHT } from "config/tags";
import t, { AsHtml } from "utils/translate";

// Assumes meters.
const getGoalWeightMinimum = height => {
  return MINIMUM_BMI_RECOMMENDED * (height / 100) ** 2;
};

// Shows error messages for goal weight entry.
export const processBmi = (profile, question) => {
  const goalWeightMetric = profile.metric[DESIRED_WEIGHT];
  const metricHeight =
    profile.metric.heightUnit === "m"
      ? profile.metric.height * 100
      : profile.metric.height;
  const goalWeightBMI = getBMI(metricHeight, goalWeightMetric);
  const startingWeightMetric = profile.metric[WEIGHT];
  const startingWeightBMI = getBMI(metricHeight, startingWeightMetric);
  const goalWeightAboveStart = goalWeightMetric >= startingWeightMetric;

  let goalWeightMinimum = getGoalWeightMinimum(metricHeight);
  if (profile.measurementSystem === "imperial") {
    goalWeightMinimum = convertWeight(
      goalWeightMinimum,
      "kgs",
      profile.imperial[WEIGHT_UNIT]
    );
  }

  let bmiMessage;
  let headerMessage;

  // Starting Weight Question Modal
  if (startingWeightBMI < MINIMUM_BMI) {
    bmiMessage = t("BMI_MESSAGE_CURRENT_WEIGHT");
  }

  const showStartingMessage =
    question.tags.includes(BMI_MESSAGE_CURRENT_WEIGHT) &&
    startingWeightBMI < MINIMUM_BMI;

  if (bmiMessage && showStartingMessage) {
    bmiMessage = (
      <div>
        <AsHtml value={bmiMessage} />
      </div>
    );

    headerMessage = t("BMI_TOO_LOW");

    return {
      bmiMessage,
      headerMessage,
      showStartingMessage
    };
  }

  // Goal Weight Question Modal
  if (goalWeightBMI < MINIMUM_BMI) {
    bmiMessage = t("BMI_MESSAGE");
    bmiMessage = bmiMessage.replace(
      "<goal>",
      `${getWeightLocalized(profile, goalWeightMinimum).numberFormatted}`
    );
  } else if (goalWeightAboveStart) {
    bmiMessage = t("BMI_MESSAGE_CURRENT_BIGGER_GOAL");
  }

  bmiMessage = (
    <div>
      <AsHtml value={bmiMessage} />
    </div>
  );

  headerMessage = t("GOAL_WEIGHT_MODAL");

  const showGoalMessage =
    question.tags.includes(BMI_MESSAGE) &&
    goalWeightMetric &&
    (goalWeightBMI < MINIMUM_BMI || goalWeightAboveStart);

  return {
    bmiMessage,
    headerMessage,
    showGoalMessage
  };
};
